import React from 'react';

import {LoadingLine} from 'app/general/loading/LoadingLine';

export function DashboardLoadingContent() {
  return (
    <>
      {Array.from(Array(5)).map((_, i) => (
        <div
          className="row border-bottom py-2 d-flex align-items-center"
          key={i}
        >
          <div className="col-12 py-1">
            <LoadingLine height="1rem" />
          </div>
        </div>
      ))}
    </>
  );
}
